<!--suppress CssUnusedSymbol -->
<template>
    <div>
                        <v-subheader>VIEWS</v-subheader>
                    <v-list dense>
                        <v-list-item
                            id="managePersonnelLink"
                            to="/manage-personnel"
                        >
                            <v-list-item-action>
                                <v-icon size="23">fa-user-alt</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Personnel</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            id="manageJobsLink"
                            to="/manage-jobs"
                        >
                            <v-list-item-action>
                                <v-icon size="23">fa-briefcase</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Jobs</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            id="manageTeamsLink"
                            to="/manage-teams"
                        >
                            <v-list-item-action>
                                <v-icon size="23">fa-users</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Teams</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            id="manageEcsCompaniesLink"
                            to="/manage-ecs-companies"
                        >
                            <v-list-item-action>
                                <v-icon size="23">fa-th</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>ECS Companies</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>

                        <v-list-item
                            id="manageAssetsLink"
                            to="/manage-assets"
                        >
                            <v-list-item-action>
                                <v-icon size="19">fa-warehouse</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Assets</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            id="manageCourseTypesLink"
                            to="/course-types"
                        >
                            <v-list-item-action>
                                <v-icon size="19">fa-list</v-icon>
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title>Course Types</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider />
                    </v-list>
                    <v-subheader>Quick Links</v-subheader>
        <v-list dense>
            <v-list-item
                id="addPersonLink"
                to="/manage-personnel/add-person"
            >
                <v-list-item-action>
                    <i class="fas fa-user-plus" />
                </v-list-item-action>
                <v-list-item-content>
                    <v-list-item-title>Add Person</v-list-item-title>
                </v-list-item-content>
            </v-list-item>
        </v-list>
    </div>
</template>

<script>
    export default {
        name: "TheSidebarMenu",
    }
</script>

<style scoped>
    a {
        font-weight: bold;
        color: #2c3e50;
    }

    .router-link-exact-active {
        color: #42b983;
    }
</style>
